/**
 * O carimbo do que está rodando neste aparelho.
 *
 * Serve para responder uma pergunta só, que hoje não tem resposta: *o que eu
 * mandei para o ar chegou no celular do barbeiro?* O GitHub Actions ficar verde
 * responde "publicou"; ele não responde "chegou". Entre um e outro tem cache de
 * navegador, aba aberta há três dias e app na tela de início que ninguém
 * fechou — e o sintoma de qualquer um deles é o barbeiro jurando que o defeito
 * continua lá.
 *
 * Os valores entram em tempo de **build**, como todas as `VITE_*`: o `vite
 * build` roda dentro do Docker, no VPS, onde não existe `.git` no contexto da
 * imagem. Quem sabe o commit é o `scripts/publicar.sh`, que já fez o `git reset`
 * para ele antes de construir — então ele passa os dois como build args (ver o
 * Dockerfile do web).
 *
 * Fora dali — `pnpm dev`, `pnpm build` na máquina de quem desenvolve, o portão
 * do CI — não há carimbo, e a tela diz "Desenvolvimento". Deduzir uma data do
 * relógio de quem abriu o app daria um carimbo sempre atual e sempre mentiroso,
 * que é exatamente o contrário do que esta tela existe para fazer.
 */

export interface BuildStamp {
  /** SHA do commit publicado, inteiro. A tela mostra os sete primeiros. */
  commit: string;
  /** Instante do build, em UTC — formatado no fuso da barbearia, como todo o resto. */
  builtAt: string;
}

const commit = import.meta.env.VITE_BUILD_COMMIT as string | undefined;
const builtAt = import.meta.env.VITE_BUILD_TIME as string | undefined;

/**
 * O carimbo, ou `null` quando não foi construído por uma publicação.
 *
 * Os dois campos andam juntos: um commit sem data não diz se é o de agora ou o
 * de outubro, e uma data sem commit não dá o que repetir no telefone ao pedir
 * ajuda. Meio carimbo tem cara de informação e não é.
 */
export const BUILD: BuildStamp | null =
  commit && builtAt && !Number.isNaN(Date.parse(builtAt)) ? { commit, builtAt } : null;

/** `8c3f1a2` — o tanto de SHA que uma pessoa consegue ler em voz alta. */
export function shortCommit(sha: string): string {
  return sha.slice(0, 7);
}
